import styles from "./Merge.module.scss";
import DeleteIcon from "components/UI/Icons/Delete";
import MergeIcon from "components/UI/Icons/Sidecar/Merge";
import MoveUpDown from "components/UI/Icons/Sidecar/MoveUpDown";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { removeSidecarConfigNewTempActionList } from "redux/sidecar/sidecarSlice";
const MergeActionCard = ({uuid, drag, changesMade}:{uuid:string, drag?:any, changesMade:()=>void}) => {
	const [deleteHover, setDeleteHover] = useState(false);
	const dispatch = useDispatch();
	return (
		<div className={styles.card} draggable onDragEnd={drag?.handlesort}  onDragEnter={()=>{drag?.dragEnter(drag)}} onDragStart={()=>{drag?.dragStart(drag)}}> 
			<p>
				{drag && <MoveUpDown />}
				<MergeIcon />
				<span>Merge</span>
			</p>
			<p>
				{/* <EditIcon color="icon-primary" /> */}
				{uuid &&
				<>
					<span className={styles.actionButton} onClick={()=>{changesMade(); dispatch(removeSidecarConfigNewTempActionList(uuid))}} onMouseOver={() => {setDeleteHover(true);}} onMouseOut={() => {setDeleteHover(false);}}><DeleteIcon color={deleteHover?"support-danger-default" : "icon-primary"} /></span>
				</>}
			</p>
		</div>
	);
};

export default MergeActionCard;
